import store from "../store"

export const REQUEST_SUCCESS = async (config) => {
  const {access_token} = store.state.Auth
  if (_.isEmpty(access_token)) {
    return config
  }
  config.headers.Authorization = `Bearer ${access_token}`;
  return config
}

export const REQUEST_ERROR = error => Promise.reject(error)
export const RESPONSE_ERROR = async error => {
  if (!error.response) {
    store.dispatch('errorNetwork')
    return Promise.reject(error);
  }
  if (error.response.status === 401) {
    store.dispatch('Auth/doLogout')
  }

  return Promise.reject(error)
}



// WEBPACK FOOTER //
// ./src/router/interceptors.js